/**
 * Utility functions for personnel records
 */

/**
 * Get the unique identifier for a personnel record
 * @param {Object} record - The personnel record object
 * @returns {string|null} The unique identifier for the record
 */
export function getPersonnelRecordId(record) {
  if (!record) return null;
  // Try to get uid from user object first, fallback to uid property, or use a combination
  return (
    record.user?.uid ||
    record.uid ||
    `${record.firstName}_${record.lastName}_${record.personnelNumber || ""}`
  );
}

/**
 * Get the display name for a personnel record
 * @param {Object} record - The personnel record object
 * @returns {string} The formatted display name
 */
export function getPersonnelRecordDisplayName(record) {
  if (!record) return "";
  return `${record.firstName || ""} ${record.lastName || ""}`.trim();
}
